const config = {
    api: 'https://api.boardv2.martendenheijer.nl'
    // api: 'http://192.168.1.176:3004',
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js